import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito diagnóstico previo?',
    a: 'No. El Tomo 1 incluye un test de autodiagnóstico neuro-digestivo desde el primer día.'
  }, {
    q: '¿Hay que comprar productos importados?',
    a: 'No. Todo se consigue en cualquier súper o verdulería argentina. El Tomo 4 tiene una guía con marcas locales específicas.'
  }, {
    q: '¿Cuándo empieza a funcionar?',
    a: 'Las primeras mejoras aparecen entre los días 3 y 7. Los resultados sostenidos, entre el día 14 y 21.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. 14 días, 100% de devolución, sin preguntas. Menos del 1% la necesitó.'
  }, {
    q: '¿Es 100% digital?',
    a: 'Sí. Acceso inmediato en menos de 5 minutos tras el pago.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-brand-black" data-id="element-96">
      <div className="container mx-auto px-4" data-id="element-97">
        <div className="max-w-3xl mx-auto" data-id="element-98">
          <div className="text-center mb-12" data-id="element-99">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-100">
              ❓PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-4" data-id="element-101">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-800 rounded-xl overflow-hidden bg-brand-dark" data-id="element-102">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-103">
                  <span className="font-bold text-lg text-white pr-8" data-id="element-104">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-light shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-105" />
                </button>
                <AnimatePresence data-id="element-106">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-107">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-gray-800/50 mt-2" data-id="element-108">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}